import { COLOR } from "../../config/color";

const rootLayoutStyle: React.CSSProperties = {
  height: '100vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  color: COLOR.WHITE,
  flex: '0 0 auto',
  paddingInline: 48,
  lineHeight: '64px',
  justifyContent: 'space-between'
};

const siderStyle: React.CSSProperties = {
  // textAlign: 'center',
  lineHeight: '120px',
  color: COLOR.WHITE,
  height: '100%',
  paddingTop: '2rem',
  backgroundColor: COLOR.WHITE,
};

const contentStyle: React.CSSProperties = {
  flex: '1 1 auto',
  minHeight: 0,
  overflow: 'hidden',
};

const layoutStyle: React.CSSProperties = {
  overflow: 'hidden',
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  // padding: '24px 0'
};

const logoStyle: React.CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  height: '2.75rem',
  justifyContent: 'center',
  // overflow: 'hidden',
  // width: '100%',
  // maxWidth: '100%',
};

const titleStyle: React.CSSProperties = {
  color: 'white',
};

const logoutStyle: React.CSSProperties = {
  color: COLOR.WHITE,
};

export {
  rootLayoutStyle,
  headerStyle,
  contentStyle,
  layoutStyle,
  siderStyle,
  logoStyle,
  titleStyle,
  logoutStyle
}